import { apiRequest } from '@lumlab/platform-product/web';
import { analysisCommands, analysisCommandResult } from '../contract/analysis-cases.ts';

export async function analysisCommand(input: unknown) {
    const result: unknown = await apiRequest('/api/admin/products/tenders/analysis/commands', {
        method: 'POST',
        body: analysisCommands.parse(input),
    });
    return analysisCommandResult.parse(result).result;
}
